
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"49","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.677 13.429L35.332.287A.988.988 0 0034.638 0h-24.62C6.296 0 3.279 3.184 3.279 7.11v26.235H0V51.13h3.28v1.604c0 3.914 3.028 7.11 6.738 7.11h32.244c3.722 0 6.738-3.184 6.738-7.11V14.207c0-.287-.108-.575-.323-.778zM34.302 2.202l11.61 11.442h-6.32c-2.92 0-5.29-2.334-5.29-5.194V2.202zm12.663 50.532c0 2.741-2.106 4.967-4.703 4.967H10.018c-2.597 0-4.704-2.226-4.704-4.967V51.13h22.382c4.368 0 7.899-3.985 7.899-8.892s-3.543-8.893-7.9-8.893H5.316V7.109c0-2.74 2.106-4.967 4.703-4.967h22.25V8.45c0 4.045 3.28 7.337 7.325 7.337h7.372v36.947zm-40.67-6.008v-8.977h3.436c.993 0 1.771.252 2.322.766.55.515.837 1.185.837 2.023 0 .838-.275 1.52-.838 2.023-.562.502-1.34.766-2.321.766H7.79v3.399H6.297zm8.415 0v-8.977h2.968c1.137 0 2.058.36 2.777 1.066.718.706 1.065 1.627 1.065 2.74v1.365c0 1.125-.36 2.035-1.065 2.74-.719.707-1.64 1.066-2.777 1.066H14.71zm13.955-5.027v1.197h-3.614v3.83h-1.508v-8.977h5.745v1.197h-4.25v2.741h3.627v.012z","fill":"#0094D9"}}),_c('path',{attrs:{"d":"M10.987 41.675c.276-.3.42-.67.42-1.125 0-.455-.144-.838-.42-1.137-.275-.3-.694-.455-1.256-.455H7.79v3.172h1.94c.562-.012.97-.156 1.256-.455zM17.678 38.958h-1.472v6.583h1.472c.718 0 1.292-.24 1.711-.73.42-.49.635-1.113.635-1.88v-1.376c0-.754-.216-1.376-.635-1.867-.419-.49-.993-.73-1.711-.73z","fill":"#0094D9"}})])
          )
        }
      }
    